export default __webpack_public_path__ + "static/media/check_up.91c12229.png";